import { api } from '../index';

const prefix = '/api/shopify/order/';

export function apiGetThirdPartyCustomersByCode(customer_code, store_no) {
	return api.get(prefix + 'getThirdPartyCustomersByCode', { params: { customer_code, store_no } });
}

export function apiGetCustomerByThirdPartyCustomerId(store_no, program_customer_id) {
	return api.get(prefix + 'getCustomerByThirdPartyCustomerId', { params: { store_no, program_customer_id } });
}

export function apiCreateNewCustomer(param) {
	return api.post(prefix + 'createNewCustomer', param);
}

export function apiInsertThirdPartyOrderCustomer(customer_code, program_customer_id, store_no) {
	return api.get(prefix + 'insertThirdPartyOrderCustomer', { params: { customer_code, program_customer_id, store_no } });
}

export function apiDeleteThirdPartyOrderCustomerById(cust_no) {
	return api.get(prefix + 'deleteThirdPartyOrderCustomerById', { params: { cust_no } });
}

export function apiGetShopifyOrderForCreate(store_no, as_of_date) {
	return api.get(prefix + 'getShopifyOrderForCreate', { params: { store_no, as_of_date } });
}

export function apiGetShopifyOrderForUpdate(store_no, as_of_date) {
	return api.get(prefix + 'getShopifyOrderForUpdate', { params: { store_no, as_of_date } });
}

export function apiGetFulfilledSalesOrder(store_no, as_of_date) {
	return api.get(prefix + 'getFulfilledSalesOrder', { params: { store_no, as_of_date } });
}

export function apiUpdateShopifyOrderInInvoice(order_no) {
	return api.get(prefix + 'updateShopifyOrderInInvoice', { params: { order_no } });
}

export function apiInsertSalesOrder(param) {
	return api.post(prefix + 'insertSalesOrder', param);
}

export function apiUpdateSalesOrder(param) {
	return api.post(prefix + 'updateSalesOrder', param);
}
